export default __webpack_public_path__ + "static/media/mainLogo.5d860743.png";